import { useEffect, useState } from 'react';
import API from './axios';
import { SkeletonChannelRow, staggerStyle } from '../components/Skeleton';
import '../imgs/radar.webp';

const ChannelList = () => {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/channels')
      .then((res) => {
        const allowedCategories = [
          '⤚━[Public Channels]━⤙',
          '⤚━[Voice Channels]━⤙',
        ];
        const filteredChannels = res.data.filter((channel) =>
          allowedCategories.includes(channel.parent)
        );
        setChannels(filteredChannels);
      })
      .catch((err) => {
        console.error('Failed to fetch channels:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  // Placeholder rows occupy the same height as the real list, so the sidebar
  // does not grow and shove the page around when the channels arrive.
  if (loading) {
    return (
      <div className="channel-list-container">
        <div className="channel-divider">
          {Array.from({ length: 6 }, (_, i) => (
            <SkeletonChannelRow key={i} />
          ))}
        </div>
      </div>
    );
  }

  const groupedChannels = channels.reduce((acc, channel) => {
    if (!acc[channel.parent]) {
      acc[channel.parent] = [];
    }
    acc[channel.parent].push(channel);
    return acc;
  }, {});

  const capitalizeName = (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  // Index runs across every group so the stagger reads as one cascade rather
  // than restarting per category.
  let rowIndex = 0;

  return (
    <div className="channel-list-container">
      {Object.entries(groupedChannels).map(([parent, groupChannels]) => (
        <div key={parent} className="channel-category">
          <h4 className="channel-parent">{parent}</h4>
          <div className="channel-divider">
            <ul className="channel-list">
              {groupChannels.map((channel) => (
                <li
                  key={channel.id}
                  className="stagger-item"
                  style={staggerStyle(rowIndex++)}
                >
                  <strong> {channel.name}</strong>
                  {channel.members && channel.members.length > 0 && (
                    <ul className="voice-members">
                      {channel.members.map((member) => (
                        <li key={member.id}>
                          <img
                            src={member.avatar}
                            alt={capitalizeName(member.username)}
                            className="member-avatar"
                          />
                          <span>{capitalizeName(member.username)}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChannelList;
